export const PRODUCTION = true;

const Constatnt = {

    APP_NAME: 'react_admin_panel',
    API_KEY: process.env.REACT_APP_API_KEY,
    API_BASE_URL: !PRODUCTION ? process.env.REACT_APP_API_BASE_URL : process.env.REACT_APP_LIVE_API_BASE_URL,
    KEY: process.env.REACT_APP_KEY,
    IV: process.env.REACT_APP_IV,
    BASE_URL: 'assets/images/page-images/',
    AMARJIT:process.env.REACT_ENC,
    LOGO:'https://roofestimator-live.s3.amazonaws.com/roof_logo/roof_logo.png',
    language: 'en',

    S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
    S3_REGION: process.env.REACT_APP_S3_REGION,
    S3_URL: process.env.REACT_APP_S3_URL,
    S3_ACCESS_KEY: process.env.REACT_APP_ACCESS_KEY,
    S3_SECRET_ACCESS_KEY: process.env.REACT_APP_SECRET_ACCESS_KEY,
}



export const AWS_STORAGE_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME;
export const AWS_ACCESS_KEY_ID = process.env.REACT_APP_ACCESS_KEY;
export const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;
export const AWS_S3_REGION_NAME = process.env.REACT_APP_S3_REGION;




//constants 
export const AUTH = "auth";
export const USER = "user";
export const GAMES = "games";
export const DATE_FORMAT = "YYYY-MM-DD";
export const ABBREVIATED_DATE_FORMAT = "D MMM";
export const ABBREVIATED_FULL_DATE_FORMAT = "DD MMM, YYYY";
export const DATE_TIME_FORMAT = "DD MMM YYYY, hh:mm A";
export const DATE_TIME_MONTHE_WISE_FORMAT = "MMM DD YYYY, hh:mm A";
export const DATE_DASH_TIME_FORMAT = "D-M-YYYY h:mm A";
export const DATE_YEAR_WISE_DASH_TIME_FORMAT = "YYYY-MM-DD h:mm A";
export const DATE_LOCAL_DASH_TIME_FORMAT = "YYYY-MM-DDTHH:mm";
export const DATE_DOT_TIME_FORMAT = "DD.MM.YYYY H:mm";
export const DATE_SLASH_FORMAT = "DD/MM/YYYY";
export const DATE_WEEK_MONTHE_NAME_FORMAT = 'ddd, MMMM DD';
export const SEARCH_DELAY = 1000;
export const PER_PAGE_DATA = 8;
export const COUNT_PER_PAGE = 10;
export const PUBLIC_URL = process.env.PUBLIC_URL;

export default Constatnt